<template>
  <div class="h-screen bg-white">
    <slot />
  </div>
</template>
